export const ErrorTranslation = {
  en: {
    pageNotFound: 'Page not found'
  },
  pt: {
    pageNotFound: 'Página não encontrada'
  }
}
